import React from 'react';
import { useNavigate } from 'react-router-dom';
import {Button} from '../../../components/ui/Button';

const CreateEventActions = ({ 
  onCreateEvent, 
  isLoading, 
  isFormValid,
  participantCount 
}) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-subtle">
      <div className="flex flex-col sm:flex-row gap-4">
        <Button
          variant="outline"
          onClick={handleCancel}
          disabled={isLoading}
          fullWidth
          className="sm:w-auto"
        >
          Cancel
        </Button>
        
        <Button
          variant="default"
          onClick={onCreateEvent}
          loading={isLoading}
          disabled={!isFormValid}
          iconName="Plus"
          iconPosition="left"
          fullWidth
          className="sm:flex-1"
        >
          {isLoading ? 'Creating Event...' : 'Create Event'}
        </Button>
      </div>

      {/* Form Status Summary */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Participants:</span>
          <span className="font-medium text-foreground">
            {participantCount} {participantCount === 1 ? 'person' : 'people'}
          </span>
        </div>
        
        {!isFormValid && (
          <div className="mt-2 p-2 bg-warning/10 rounded border border-warning/20">
            <p className="text-xs text-warning-foreground">
              Please fill in all required fields to create the event
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateEventActions;
